export function updateDataGrouping(chart, min, max) {
	const monatsgrenze = 5 * 365 * 24 * 3600 * 1000 //Grenze für den Wechseln hier angeben. Aktuell 5 jahre

	let groupingEnabled = false

	if (max - min > monatsgrenze) {
		groupingEnabled = true
	}

	const plotOptions = {
		plotOptions: {
			series: {
				dataGrouping: {
					enabled: groupingEnabled,
				},
			},
		},
	}

	chart.update(plotOptions)
}

export function updateBewertungPlotline(chart) {
	const xAxis = chart.xAxis[0]
	const plotLine = xAxis.options.plotLines?.find((pl) => pl.id === "bewertungsplotline")
	if (!plotLine) return

	if (chart.options.plotOptions.series.dataGrouping.enabled) {
		plotLine.value = plotLine.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000
	} else {
		plotLine.value = plotLine.bewertungsdatum
	}

	xAxis.update({ plotLines: [plotLine] })
}

export function zoomIn(chart, event) {
	// if (event.resetSelection) return true
	// If zoom reset, trigger callback
	if (event.resetSelection) {
		chart.onZoomReset?.()
		return true
	}

	const dataGrouping = event.target.xAxis[0].chart.options.plotOptions.series.dataGrouping
	const min = event.xAxis[0].min
	const max = event.xAxis[0].max
	const monatsgrenze = 5 * 365 * 24 * 3600 * 1000

	// Always trigger zoom-in callback before any early return
	chart.onZoomIn?.()

	if (max - min < monatsgrenze) {
		chart.data.anzeigeformat = "monat"
	} else {
		chart.data.anzeigeformat = "jahr"
	}

	// Wenn das DataGrouping enabled ist, das bedeutet, das Chart zeigt die Werte auf Jahresbasis an
	// und der zum Zoom ausgewählte Bereich ist kleiner als die Monatsgrenze, er also nach dem Zoomen
	// in die Monatsansicht wechselt sollte der Max-Wert des Zooms das Ende des Jahres anzeigen, welches in der Auswahl als X-Wert angezeigt wurde. Der Min-Wert des Zooms
	if (max - min < monatsgrenze && dataGrouping.enabled) {
		const xAxis = event.target.xAxis[0],
			minDate = new Date(min),
			neuesMinJahr = minDate.getFullYear() + (minDate.getMonth() > 5 ? 1 : 0),
			maxDate = new Date(max),
			neuesMaxJahr = maxDate.getFullYear() + (maxDate.getMonth() > 5 ? 1 : 0)

		xAxis.setExtremes(Date.UTC(neuesMinJahr, 0, 1), Date.UTC(neuesMaxJahr, 11, 1))
		chart.data.anzeigeformat = "monat"
		return false
	}
}

export function updateXAxisMinMax(chartDepot) {
	const seriesMaxValues = chartDepot.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
		xAxisMaxValue = Math.max(
			chartDepot.data.enddatum,
			...seriesMaxValues.filter((element) => element !== undefined),
		)
	chartDepot.chart.xAxis[0].update({ min: chartDepot.data.startdatum, max: xAxisMaxValue })
}

export function updateBewertungLinie(chartDepot) {
	const xAxis = chartDepot.chart.xAxis[0]
	const plotLine = xAxis.options.plotLines?.find((pl) => pl.id === "bewertungsplotline")
	if (!plotLine) return

	plotLine.bewertungsdatum = chartDepot.data.bewertungsdatum
	plotLine.value = chartDepot.data.bewertungsdatum
	plotLine.label.text = `Aktuelle Bewertung<br>zum ${moment(new Date(chartDepot.data.bewertungsdatum)).format("MM / YYYY")}`

	if (chartDepot.chart.options.plotOptions.series.dataGrouping.enabled) {
		plotLine.value = plotLine.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000
	}

	xAxis.update({ plotLines: [plotLine] })
}
